





































































































































































import { Component, Vue } from "vue-property-decorator";
import {BIcon, BIconDot} from "bootstrap-vue";

@Component({
  components: {
    BIcon,
    BIconDot,
    
  }
})
export default class ShareSchematic extends Vue {}
